export default [
  {
    path: "/purchases",
    name: "Purchases",
    component: () => import("@/pages/purchase/PurchasesPage.vue"),
  },
  {
    path: "/purchases/new",
    name: "NewPurchase",
    component: () => import("@/pages/purchase/NewPurchasePage.vue"),
  },
  {
    path: "/purchases/details/:purchaseCode",
    name: "PurchaseDetails",
    component: () => import("@/pages/purchase/PurchaseDetailsPage.vue"),
  },
  {
    path: "/purchases/invoices",
    name: "PurchaseInvoices",
    component: () => import("@/pages/accounting/InvoicesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/purchase/suppliers",
    name: "Suppliers",
    component: () => import("@/pages/purchase/SuppliersPage.vue"),
  },
  {
    path: "/purchase/suppliers/new",
    name: "NewSupplier",
    component: () => import("@/pages/purchase/NewSupplierPage.vue"),
  },
  {
    path: "/purchase/supplier/due",
    name: "SupplierDue",
    component: () => import("@/pages/purchase/SuppliersDuePage.vue"),
  },
  {
    path: "/purchase/payment",
    name: "PurchasePayment",
    component: () => import("@/pages/purchase/PurchasePaymentPage.vue"),
  },
  {
    path: "/purchase/payment/new",
    name: "NewPurchasePayment",
    component: () => import("@/pages/purchase/NewPurchasePaymentPage.vue"),
  },
  {
    path: "/purchase/return",
    name: "PurchaseReturn",
    component: () => import("@/pages/purchase/PurchaseReturnPage.vue"),
  },
  {
    path: "/purchase/return/new",
    name: "NewPurchaseReturn",
    component: () => import("@/pages/purchase/NewPurchaseReturnPage.vue"),
  },
];